import { fetchConfigActivityGroups, fetchActivityGroups } from "../api";
import { sectionTemplate, defaultSections, optionsDefaultSections, defaultPages } from "../data/default-sections";

function buildFromTemplate(template, source) {
  return {
    ...template,
    ...source,
    prevGroupId: source.groupId ?? null, // si quieres forzar campos derivados
  }
}

function extendDefaultSections() {
  const sections = [...defaultSections];

  optionsDefaultSections.forEach(item => {
    const obj = buildFromTemplate(sectionTemplate, item);
    sections.push(obj);
  });

  return sections;
}

async function initConfigDetailedReport(projectId) {
  try {
    const groups = await fetchActivityGroups(projectId);

    const flattenGroups = (arr) => {
      const result = {}

      const recurse = (groups) => {
        groups.forEach(g => {
          if (g.custom_code) result[g.custom_code] = g.id
          if (g.children?.length) recurse(g.children)
        })
      }

      recurse(arr);
      return result;
    }

    const codeToGroupId = flattenGroups(groups);

    let config = {
      pages: defaultPages,
      sections: []
    }

    if ( Object.keys(codeToGroupId).length === 0 ) {
      config.sections = extendDefaultSections()
    } else {

      config.sections = defaultSections;

      Object.entries(codeToGroupId).forEach(([code, groupId]) => {
        let section = optionsDefaultSections.find(s => s.code === code);
        if (! section) {
          section = {
            code,
            name: null
          }
        }

        section.groupId = groupId;
        section.hasAssociatedGroup = true;
        section.visible = true;

        config.sections.push(buildFromTemplate(sectionTemplate, section));
      });
    }

    return config;

  } catch (e) {
    console.error('Error al iniciar configuracion de reporte detallado:', e);
    throw e;
  }
}

export async function getConfigDetailedReport(projectId) {
  try {
    const configActivityGroups = await fetchConfigActivityGroups(projectId);

    const configDetailedReport = configActivityGroups?.reports?.detailed || null;

    let config = {
      pages: [],
      sections: []
    };

    if (! configDetailedReport) {
      config = await initConfigDetailedReport(projectId);
    }
    else {
      if (! configDetailedReport.pages ) {
        config.pages = defaultPages;
      } else {
        configDetailedReport.pages.forEach(item => {
          config.pages.push(item);
        })
      }

      if (! configDetailedReport.sections ) {
        config.sections = extendDefaultSections();
      } else {
        // cargar configuracion de sections que viene
        configDetailedReport.sections.forEach(item => {
          const obj = buildFromTemplate(sectionTemplate, item);
          config.sections.push(obj);
        })
      }
    }

    return config;
  } catch (e) {
    console.error("Error manipulando configuracion de grupos de actividad", e);
    throw e;
  }
}